module.exports = __webpack_public_path__ + "static/media/BOS-NEW.f3c0096f.apng";